const pending = new Set();
const listeners = new Set();
function notify() { for (const listener of listeners) listener(); }
export const subscribeLoading = listener => { listeners.add(listener); return () => listeners.delete(listener); };
export const getLoadingCount = () => pending.size;
export function beginLoading() {
  const task = Symbol(); pending.add(task); notify();
  return () => { if (pending.delete(task)) notify(); };
}
